import styled, { css } from 'styled-components'

import { assetPrefix } from 'config/env_config'

import { MEDIA } from 'utils/constants'

const { MOBILE_UP, MOBILE } = MEDIA

export const StepsContainer = styled.div`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  list-style-type: none;
  background-color: var(--the-white);
  z-index: 3;
  margin: 0;
  left: 0;
  position: sticky;
  top: 58px;
  width: 100%;
  padding: 16px 0;

  @media screen and ${MOBILE_UP} {
    top: 86px;
  }

  @media screen and ${MOBILE} {
    position: initial;
  }
`

export const BackButtonWrapper = styled.div`
  width: 100%;
  height: 40px;
  position: relative;
  max-width: 1040px;
  margin-left: 16px;

  @media screen and (max-width: 1060px) {
    max-width: unset;
    margin-left: 0;
  }
`

export const BackButton = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  gap: 1.6rem;

  font-size: 16px;
  line-height: 1.6rem;
  font-weight: 600;
  font-family: var(--primary-font);
  color: var(--cobasi-blue-light-8);

  cursor: pointer;

  :before {
    content: url('${assetPrefix}/static/icons/chevron-left.svg');
    width: 2.4rem;
    height: 2.4rem;
  }

  :active {
    transition: 0.1s;
    opacity: 0.3;
  }

  :hover {
    transition: 0.3s;
    opacity: 0.8;
  }
`

export const WrapperSchedulingActions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  background-color: #fff;
  padding: 24px 16px;
  box-shadow: 0px -1px 2px rgba(0,0,0,0.12), 0px 4px 8px rgba(0,0,0,0.08);


  .nextButton {
    max-width: 364px;
  }


  button {
    max-width: 364px;
    width: 100%;

    &.backButton {
      &:last-of-type {
        margin-bottom: 0px;
      }
    }

  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 558px;
    width: 100%;
    gap: 24px;
    ${props => props.finalStep && css`
      justify-content: center;
    `}

    @media screen and (max-width: 800px) {
      margin: 0 16px;
    }


    margin: 0;
    ${props => props.finalStep && css`
      flex-direction: row;
    `}

    @media screen and ${MOBILE} {
      ${props => props.finalStep && css`
        flex-direction: column;
    `}
    }

  }
`
